import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { inject } from "@angular/core";
import { LocalStorageService } from "../services/local-storage.service";
import { finalize, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Router } from "@angular/router";

export function httpRequestInterceptorFn(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    const localStorageService = inject(LocalStorageService);
    const router = inject(Router);
    let apiNum = 0;

    try {
        let token: string = localStorageService.getAccessToken();
        if (!req.headers.has("Authorization") && token) {
            req = req.clone({
                setHeaders: { Authorization: `Bearer ${token}` },
            });
        }

        if (apiNum == 0) apiNum++;

        return next(req).pipe(
            finalize(() => {
                --apiNum;
            }),
            catchError((err) => {
                console.error(err);
                if (err.status === 401) {
                    err.error = "Session expired";
                    localStorageService.clearLocalStorage();
                    router.navigateByUrl("error");
                } else if (err.status === 0) {
                    err.error = "Unable connect to server.";
                }
                return throwError(() => err.error);
            }),
        );
    } catch (error) {
        return next(req);
    }
}
